import axios from 'axios';
import * as Sentry from '@sentry/browser';

class UserService {
  constructor() {
    this.api_url = process.env.VUE_APP_URL_API_USER;
  }

  async getUserData(userId) {
    try {
      const response = await axios.get(`${this.api_url}/usuario/dados`, {
        params: { id: userId },
      });
      return response.data;
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  }

  async getStates() {
    try {
      const response = await axios.get(`${this.api_url}/usuario/estados`);
      return response.data;
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  }
}

export default new UserService();
